// import { cn } from '@/utilities/ui'

import { BillCard } from '@/components/legislative-tracker/BillCard'

import type { Bill, Topic } from '@/payload-types'

export const RelatedContent = ({
  relatedBills,
  allBillTopics,
}: {
  relatedBills: Bill[]
  allBillTopics: Topic[]
}) => {
  return (
    <div className="flex flex-col gap-3 max-md:[&>.bill-card]:w-full">
      {relatedBills.map((relatedBill) => (
        <BillCard
          key={relatedBill.id}
          bill={relatedBill}
          allBillTopics={allBillTopics}
          size="small"
        />
      ))}
    </div>
  )
}
